import apiRequest from "../../utils/apiRequest";

const readSingleNotificationApi = async (notificationId) => {
    return await apiRequest(`makeNotificationRead/${notificationId}`, 'post');
};

export default readSingleNotificationApi;
